import axis from "../images/axisBank.svg";
import icci from "../images/icci.svg";
import hdfc from "../images/hdfcbank.svg";
import kotak from "../images/kotak.svg";
import pnb from "../images/pnb.svg";
import sbi from "../images/sbi.svg";
export const ConvertDatetoStandard=(originalDateTime)=>{

const date = new Date(originalDateTime?originalDateTime:"2021-06-29T10:51:19.763Z");
const options = { year: 'numeric', month: 'long', day: 'numeric' };
const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);
return formattedDate;

}

export const  HandleNotLinkedAccountNumbers=(DiscoveredAccounts,LinkedAccounts,fipid,fipname)=>{
    if(!LinkedAccounts)
    {
       return DiscoveredAccounts;
    }
    if(!DiscoveredAccounts)
    {
      return [];
    }
   //  console.log("linked ",LinkedAccounts.length)
   //  console.log("discovered",DiscoveredAccounts.length);
 const Accounts=[];

    for(let i=0;i<DiscoveredAccounts.length;i++)
    {
        let f=1;
         for(let j=0;j<LinkedAccounts.length;j++)
         {
             if(fipid==LinkedAccounts[j].fipId && DiscoveredAccounts[i].maskedAccNumber==LinkedAccounts[j].maskedAccNumber  && DiscoveredAccounts[i].accRefNumber==LinkedAccounts[j].accRefNumber)
             {
                
                f=0;
                break;
             }            
         }
         if(f)
         {
            Accounts.push(DiscoveredAccounts[i]);
         }
    }
    return Accounts;
}

export const FilterFipDetails=(Data)=>{
   const FipDetails=[];
   const filteraccordingToBank=new Map();
   for(let i=0;i<Data.length;i++)
   {
      const detail=Data[i];
      // console.log(detail);
      const savedDetail={
         linkRefNumber: detail.linkRefNumber,
         accType: detail.accType,
         accRefNumber: detail.accRefNumber,
         maskedAccNumber: detail.maskedAccNumber,
         FIType: detail.FIType,
         fipId: detail.fipId,
         fipName: detail.fipName
                  }
      if(filteraccordingToBank.get(detail.fipId)==null)
      {
         filteraccordingToBank.set(detail.fipId,[savedDetail]);
      }
      else{
         filteraccordingToBank.get(detail.fipId).push(savedDetail);
      }
   }
// console.log(filteraccordingToBank);
for (const [fipID, Accountlist] of filteraccordingToBank) {
     FipDetails.push({
      FIP: {
         id: fipID
         },
      Accounts: Accountlist
     })
 }

 return FipDetails;

}

export  const ImagesURL=()=>{
  const ImagesUrl=new Map();
  ImagesUrl.set('AXIS001',axis);
  ImagesUrl.set('ICICI-FIP',icci);
  ImagesUrl.set('HDFC-FIP',hdfc);
  ImagesUrl.set('KOTAK-FIP',kotak);
  ImagesUrl.set('PNB-UAT-FIP',pnb);
  ImagesUrl.set('SBIFIPPREPROD',sbi);;

  ImagesUrl.set('State Bank of India',sbi);;
  ImagesUrl.set('Punjab National Bank',pnb);;
  ImagesUrl.set('Kotak Mahindra Bank',kotak);;
  ImagesUrl.set('ICICI Bank',icci);;
  ImagesUrl.set('HDFC Bank',hdfc);;
  ImagesUrl.set('Axis Bank',axis);;


  ImagesUrl.set('STATE BANK OF INDIA',sbi);;
  ImagesUrl.set('Punjab National Bank',pnb);;
  ImagesUrl.set('Kotak Mahindra Bank',kotak);;
  ImagesUrl.set('ICICI Bank',icci);;
  ImagesUrl.set('HDFC Bank',hdfc);;
  ImagesUrl.set('Axis Bank',axis);;

return ImagesUrl;
}

export const GetFipTypeForABank=(data)=>{
   let all_fips=[]

   for(let i=0;i<data.length;i++)
   {
      all_fips.push(data[i].fi_type);
   }
   return all_fips;
}